import React, { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useLocation } from "react-router-dom";
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import "react-datetime/css/react-datetime.css";
import DateRangeIcon from '@mui/icons-material/DateRange';
// material
import {
    Stack, Divider, Card, TextField, Table, Button, Checkbox, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, Modal, Box,
    Autocomplete,Tab
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import { UserListHead } from "../../sections/@dashboard/user";
import { GetActiveMatchAction, getCurrentMatchList, PublishMatchPool, ResetPublishMatchPool } from "../../redux/actions/MatchAction";
import { GetAllContestAction, GetContestListAction } from "../../redux/actions/ContestActions";
import "react-toastify/dist/ReactToastify.css";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import { SeriesDateAction } from "src/redux/actions/SeriesAction";
import Loader from "src/components/Loader";
import { toast } from "react-toastify";
import { getMatchList } from 'src/redux/actions/ReportManagement';
import { TabContext, TabList, TabPanel, } from "@mui/lab";
import moment from 'moment';

export default function ActivePoolList() {
    const location = useLocation()
    const dispatch = useDispatch();
    let { id } = useParams();
    const activePools = useSelector(state => state.contests.active_contest)
    let sActivePools = activePools && activePools.data && activePools.data.data;
    const poolListData = useSelector((state) => state.matches.active_pool_list.data);
    const statusSelector = useSelector(state => state.matches.match_status)

    const [startValueDate, setStartValueDate] = useState(dayjs(new Date()));
    const [endValueDate, setEndValueDate] = useState(dayjs(new Date()));
    const [page, setPage] = useState(0);
    const [clickStatus, setClickStatus] = useState(false)
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("name");
    const [openpop, setOpenPop] = useState(false);
    const [publichClick, setPublichClick] = useState(false);
    const [filterContestList, setFilterContestList] = useState();
    const [getMatchListName1, setMatchListName1] = useState();
    const [getMatchListName2, setMatchListName2] = useState();
    const [value, setValue] = useState("CONTESTTAB");
    const [isseries,setIsseries]=useState(window?.location?.pathname?.indexOf("series")>-1?"s":"m")
    
    const MatchListData = useSelector((state) => state?.matches?.active_match_list?.data?.match_list)
    let params1 = null;

    console.log("location.state-->>",location.state)

    const [state, setState] = useState({
        totalCountPoolList: 0,
        logoImg: [],
        joinfee: null,
        totalwinamt: null,
        maxteams: null,
        winners: null,
        contest_id: null,
        pool_text: "Add Pool",
        countrytype: "all",
        matchType: isseries,
        isCheckedPool: 1,
        contest_id_pool: null,
        contest_id_pool_date: null,
        pool_start_date: "",
        pool_end_date: ""
    });
    const [editState, setEditState] = useState({
        joinfee: null,
        totalwinamt: null,
        maxteams: null,
        winners: null,
        pmin: null,
        pmax: null,
        pamount: null,
        poolmaster_id: null,
    });

   

    // let activeSendData = {
    //     ...sendData,
    //     countrytype: "+91"
    // }

    useEffect(() => {
        let sendData = {
            match_id: id,
            contest_id: state.contest_id_pool,
            type: isseries,
            gtype: location.state.gtype,
            
        }
        if (state.countrytype !== "all") {
            sendData["countrytype"] = state.countrytype
        }
        if(value==="POOLTAB"){
            sendData["iscontest"]=0
        }else{
            sendData["iscontest"]=1
        }

        dispatch(GetAllContestAction(sendData));
        dispatch(GetActiveMatchAction(page + 1, rowsPerPage, sendData))
        setClickStatus(false)
    }, [dispatch, page, rowsPerPage])

    useEffect(() => {
        let sendData = {
            match_id: id,
            contest_id: state.contest_id_pool,
            type: isseries,
            gtype: location.state.gtype,
            
        }
        if (state.countrytype !== "all") {
            sendData["countrytype"] = state.countrytype
        }

        if(value==="POOLTAB"){
            sendData["iscontest"]=0
        }else{
            sendData["iscontest"]=1
        }

        if (Object.keys(statusSelector).length > 0 && publichClick) {
            dispatch(GetActiveMatchAction(page + 1, rowsPerPage, sendData))
            dispatch(GetAllContestAction(sendData));
            setClickStatus(false)
            setPublichClick(false)
            dispatch(ResetPublishMatchPool())
        }
    }, [statusSelector, page, rowsPerPage, publichClick])

    useEffect(() => {
        var new_arr = poolListData && poolListData?.contestData?.filter((value, index, self) =>
            index === self.findIndex((t) => (
                t._id === value._id
            ))
        )
        setFilterContestList(new_arr)
    }, [poolListData])

    useEffect(() => {
        let dataMatch={"game_type":location?.state?.gtype,
        "league_id":id};
        dispatch(getCurrentMatchList(1, 10,dataMatch));
       
    }, [dispatch]);

    const stateHandler = (key, value) => {
        console.log("key, value--->>",key, value);
        state[key] = value;
        editState[key] = value;
        setEditState({ ...editState });
        setState({ ...state });
        let data = {
            match_id: id,
            contest_id: state.contest_id_pool,
            type: location.state.type,
            gtype: location.state.gtype
        }

        if(value==="POOLTAB"){
            data["iscontest"]=0
        }else{
            data["iscontest"]=1
        }

        if (key === "countrytype") {
            if (value !== "all") {
                data["countrytype"] = value
            }
        }
        dispatch(GetActiveMatchAction(page + 1, rowsPerPage, data));
        
    };

    useEffect(() => {
        if (poolListData !== undefined) {
            setState({
                ...state,
                totalCountPoolList: poolListData.total_count,
            });
        }
    }, [poolListData]);

    const handleRequestSort = (_, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "500px",
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
        border: "none",
        borderRadius: "15px",
    };

    const handleSeriesDateSubmit = () => {
        let date_start=getMatchListName1.date_start_ist;
        console.log("date_start--->>",getMatchListName1,getMatchListName2);
        let date_end=getMatchListName2.date_start_ist;
        console.log("date_start--->>",date_end);
        if (date_end >= date_start) {
            let sendData = {
                contest_id: state.contest_id_pool_date,
                date_start: getMatchListName1.date_start_ist,
                date_end: getMatchListName2.date_start_ist,
                matchid_start:getMatchListName1.match_id,
                matchid_end:getMatchListName2.match_id,
                gtype: location.state.gtype,
                league_id: id,
                session_id: id,
            }
            console.log("sendData--->>",sendData)
             dispatch(SeriesDateAction(sendData))
             setOpenPop(false)
        } else{
            toast.error("End date can't be greater start date")
        }
    }

    const onChangeMatchList1 = (event, values) => {
        console.log("event, values--->>",event, values);
        setMatchListName1(values)
    }

    const onChangeMatchList2 = (event, values) => {
        setMatchListName2(values)
    }
    
    const onChangeText=(e)=>{
        console.log("ee--->>",e.target.value)
        if(e.target.value && e.target.value.length>2){
        let data={"match_name":e.target.value,
        "rstatus":1,
    "game_type":"ckt"};
        dispatch(getCurrentMatchList(1, 10, data));
        }
    }

    let changeTab=(newValue)=>{
        console.log("newValue--->>",newValue)
        let data = {
            match_id: id,
            contest_id: state.contest_id_pool,
            type: location.state.type,
            gtype: location.state.gtype
        }
        if(newValue==="POOLTAB"){
            data["iscontest"]=0
        }else{
            data["iscontest"]=1
        }
        
        dispatch(GetActiveMatchAction(page + 1, rowsPerPage, data))

        setValue(newValue);
        //dispatch(GetMatchListByStatus(newValue,page,rowsPerPage))
    }
    const handleChange = (_, newValue) => {
        changeTab(newValue);
    };

    console.log("window.location--->>",window.location.pathname.indexOf("series")>-1)
    const dateOpenFunc = () => {
        return (
            <Modal
                open={openpop}
                onClose={() => setOpenPop(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography
                        id="modal-modal-title"
                        style={{ marginBottom: 20 }}
                        align={"center"}
                        variant="h6"
                        component="h2"
                    >
                        Select Date Range
                    </Typography>

                    <Divider />

                    <br />

                    <Stack container spacing={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            {/* <DateTimePicker
                                renderInput={(props) => <TextField {...props} />}
                                label="Start Date"
                                minDate={new Date()}
                                value={startValueDate}
                                onChange={(newValue) => {
                                    setStartValueDate(newValue);
                                }}
                            /> */}
                            <Autocomplete sinlge id="tags-outlined"
                                options={MatchListData}
                                getOptionLabel={
                                    (option) => option.title+" | "+option.date_start_ist
                                }
                                onChange={onChangeMatchList1}
                                filterSelectedOptions
                                renderInput={
                                    (params) => {
                                        if (params) {
                                            params1 = params;
                                        }
                                        return (
                                            <TextField {...params} label="Select Match List" className="txtuio" placeholder="Select Match Name List" onChange={onChangeText} />
                                        )
                                    }
                                } />
                        </LocalizationProvider>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            {/* <DateTimePicker
                                renderInput={(props) => <TextField {...props} />}
                                label="End Date"
                                value={endValueDate}
                                minDate={startValueDate}
                                onChange={(newValue) => {
                                    setEndValueDate(newValue);
                                }}
                            /> */}
                            <Autocomplete sinlge id="tags-outlined"
                                options={MatchListData}
                                getOptionLabel={
                                    (option) => option.title+" | "+option.date_start_ist
                                }

                                onChange={onChangeMatchList2}
                                filterSelectedOptions
                                renderInput={
                                    (params) => {
                                        if (params) {
                                            params1 = params;
                                        }
                                        return (
                                            <TextField {...params} label="Select Match List" placeholder="Select Match Name List" onChange={onChangeText} />
                                        )
                                    }
                             } />
                        </LocalizationProvider>
                    </Stack>

                    <Button
                        align={"center"}
                        style={{ marginTop: 20, width: "100%" }}
                        variant="contained"
                        fullWidth
                        size="large"
                        onClick={handleSeriesDateSubmit}>
                        Submit
                    </Button>
                </Box>
            </Modal>
        )
    }

    console.log("window.location.href--->>>",window.location.href.indexOf("football")>-1)
    return (
        <Page title="Active Pools">
            {clickStatus ? <Loader /> : null}

            {dateOpenFunc()}

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading={location.state.name}
                    links={[
                        { name: "Dashboard", href: "/dashboard/app" },
                        { name: "Active Matches", href:(window.location.href.indexOf("football")>-1)?"/dashboard/football/active_football_list": "/dashboard/cricket/active_match_list" },
                        { name: "Pools contest" },
                    ]}
                />
                <Card>
                    <Scrollbar>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                            <InputLabel id="countrySelector">IN/UK</InputLabel>
                            <Select
                                labelId="countrySelector"
                                value={state?.countrytype}
                                label="IN/UK"
                                onChange={({ target }) => stateHandler("countrytype", target.value)}
                            >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="+91">India</MenuItem>
                                <MenuItem value="+1">Uk</MenuItem>
                            </Select>
                        </FormControl>

                       
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <TabList onChange={handleChange} aria-label="Status management Tabs">
                                <Tab label="Contest" value="CONTESTTAB" key="1" />
                                <Tab label="Pool" value="POOLTAB" key="0" />  
                                
                            </TabList>
                        </Box>
                        <TabPanel value="CONTESTTAB" key="1">
                        <Scrollbar>
                        <TableContainer sx={{ minWidth: 800, minHeight: 400 }}>
                            <Table>
                                <UserListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={
                                        isseries === "s" ? [
                                            { id: "c_no", label: "Sr no.", alignRight: false },
                                            { id: "c_id", label: "Title", alignRight: false },
                                            { id: "c_title", label: "subtitle", alignRight: false },
                                            { id: "c_from", label: "From", alignRight: false },
                                            { id: "c_to", label: "To", alignRight: false },
                                            { id: "c_assigndate", label: "AssignDate", alignRight: false },
                                            
                                        ] :
                                            [
                                                { id: "c_no", label: "Sr no.", alignRight: false },
                                                { id: "c_id", label: "Title", alignRight: false },
                                                { id: "c_title", label: "subtitle", alignRight: false },
                                                //{ id: "c_subtitle", label: "Total Win Amt", alignRight: false },
                                                //{ id: "c_bonus", label: "Join Fee", alignRight: false },
                                                //{ id: "c_upinfo", label: "Max Teams", alignRight: false },
                                                //{ id: "c_action", label: "Winners", alignRight: false },
                                                //{ id: "c_status", label: "Status", alignRight: false },
                                            ]
                                    }
                                    rowCount={state.totalCountPoolList}
                                    // onRequestSort={handleRequestSort}
                                />
                                <TableBody>
                                    {poolListData && poolListData?.contestData?.map((data, index) => {
                                        return (
                                            <TableRow key={data.id}>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {page * rowsPerPage + (index + 1)}.
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {data.title}
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {data.subtitle}
                                                </TableCell>
                                                
                                                {isseries === "s" ?<>
                                                <TableCell component="th" scope="row">
                                                    {data?.contestdata?.date_start}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {data?.contestdata?.date_end}
                                                </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <Button onClick={() => {
                                                            {
                                                                setOpenPop(true)
                                                                dateOpenFunc(data._id)
                                                                setState({ ...state, contest_id_pool_date: data._id })
                                                            }
                                                        }}> <DateRangeIcon color="primary" />
                                                        </Button>
                                                    </TableCell>
                                                   </> :
                                                    null}

                                               
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        </Scrollbar>
                        </TabPanel>

                        
                        <TabPanel value="POOLTAB" key="0">
                        <Scrollbar>
                        <TableContainer sx={{ minWidth: 800, minHeight: 400 }}>
                            <Table>
                                <UserListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={
                                        location.state?.type === "s" ? [
                                            { id: "c_no", label: "Sr no.", alignRight: false },
                                            { id: "c_id", label: "Title", alignRight: false },
                                            { id: "c_title", label: "subtitle", alignRight: false },
                                            { id: "c_subtitle", label: "Total Win Amt", alignRight: false },
                                            { id: "c_bonus", label: "Join Fee", alignRight: false },
                                            { id: "c_upinfo", label: "Max Teams", alignRight: false },
                                            { id: "c_winner", label: "Winners", alignRight: false },
                                            { id: "c_assigndate", label: "From", alignRight: false },
                                            { id: "c_assigndate", label: "To", alignRight: false },
                                            { id: "c_status", label: "Status", alignRight: false },
                                        ] :
                                            [
                                                { id: "c_no", label: "Sr no.", alignRight: false },
                                                { id: "c_id", label: "Title", alignRight: false },
                                                { id: "c_title", label: "subtitle", alignRight: false },
                                                { id: "c_subtitle", label: "Total Win Amt", alignRight: false },
                                                { id: "c_bonus", label: "Join Fee", alignRight: false },
                                                { id: "c_upinfo", label: "Max Teams", alignRight: false },
                                                { id: "c_action", label: "Winners", alignRight: false },
                                                { id: "c_status", label: "Status", alignRight: false },
                                            ]
                                    }
                                    rowCount={state.totalCountPoolList}
                                    // onRequestSort={handleRequestSort}
                                />
                                <TableBody>
                                    {poolListData && poolListData?.contestData?.map((data, index) => {
                                        return (
                                            <TableRow key={data.id}>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {page * rowsPerPage + (index + 1)}.
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {data.title}
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {data.subtitle}
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {data?.totalwinamt}
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {data?.joinfee}
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {data?.maxteams}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {data?.winners}
                                                </TableCell>
                                                {location.state?.type === "s" ?<>
                                                <TableCell component="th" scope="row">
                                                    {data?.contestdata?.date_start}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {data?.contestdata?.date_end}
                                                </TableCell>
                                                    
                                                   </> :
                                                    null}

                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    
                                                    {((data?.contestdata?.date_start && location.state?.type === "s") || location.state?.type === "m")  && sActivePools &&
                                                        <Checkbox
                                                            checked={sActivePools[data.poolid] == 1 ? true : false}
                                                            onChange={(e) => {
                                                                e.preventDefault(); // Prevent default checkbox behavior
                                                                {
                                                                    dispatch(PublishMatchPool({
                                                                        poolmaster_id: data.poolid, isChecked: sActivePools[data.poolid] == 1 ? true : false, match_id: id, type: location.state.type,
                                                                        gtype: location.state.gtype
                                                                    }))
                                                                    setPublichClick(true)
                                                                    changeTab("POOLTAB");
                                                                    
                                                                }
                                                            }}
                                                        />
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        </Scrollbar>
                        </TabPanel>


                        </TabContext>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={state.totalCountPoolList}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}